import { Box } from '@dtx-company/design-system/src'
import { CreatePaymentMethod } from '@app/common/src/components/PlanPurchaseExperience/components/CreatePaymentMethod'
import { PaymentElementError } from '@app/plans/src/PaymentElementError/PaymentElementError'
import { useEffect, useRef } from 'react'
import { useInternalPlanPurchaseFormContext } from '../PlanPurchaseForm/context/useInternalPlanPurchaseFormContext'

export interface PlanPurchaseFormPaymentElementProps {
  heapId: string
  helperText?: string
}

export function PlanPurchaseFormPaymentElement({
  heapId,
  helperText
}: PlanPurchaseFormPaymentElementProps): JSX.Element {
  const { form, setPaymentMethodType, mountPaymentElement } = useInternalPlanPurchaseFormContext()
  const {
    formState: { errors },
    setValue,
    setError
  } = form

  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (
      !!errors.paymentElementComplete?.message &&
      containerRef.current &&
      containerRef.current.scrollIntoView
    ) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }, [containerRef, errors.paymentElementComplete?.message])

  return (
    <>
      {mountPaymentElement && (
        <Box ref={containerRef}>
          <CreatePaymentMethod
            onChange={event => {
              setPaymentMethodType(event.value.type)
              setValue('paymentElementComplete', event.complete)
            }}
            heapEventName={`${heapId}_Changed`}
            onFocus={() => setError('paymentElementComplete', {})}
          />
        </Box>
      )}
      <PaymentElementError
        errorMessage={errors.paymentElementComplete?.message}
        helperText={helperText}
      />
    </>
  )
}
